import { Translatable } from "@icc/shared/helpers";

export class BoxSideInsulation {
    id: number | null;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do indeksu */
    indexNo?: string;
    /** Kod do wydruków */
    printCode?: string;
    @Translatable({ model: 'WindowAccessories' })
    name?: string;
    /** Przypisane typy produktu */
    shutterTypesIds?: number[];
    /** Pasujące skrzynki */
    profilesIds?: number[];
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
    /** Czy ustawiono domyślnie */
    isDefault?: boolean;
}